/* exported getStorageStatus */
const getStorageStatus = (type) => {
    // set storageType variable default to localStorage
    let storageType = localStorage;
    // if parameter === 'sessions' check for sessionStorage
    if (type === 'sessionStorage') {
        storageType = sessionStorage;
    }

    const testStatus = 'testStatus';
    try {
        // try setting an item
        storageType.setItem('testStatus', testStatus);
        storageType.removeItem('testStatus');
    } catch (e) {
        // browser specific checks if local storage was exceeded
        if (e.name === 'QUATA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUATA_REACHED') {
            // local storage is full
            return 'full';
        } else {
            try {
                if (storageType.remainingSpace === 0) {
                    // IE
                    // local storage is full
                    return 'full';
                }
            } catch (e) {
                console.error(e);
                // localStorage.remainingSpace doesn't exist
            }

            // local storage might not be available
            return 'unavailable';
        }
    }
    return 'available';
};

export default getStorageStatus;
